import { SxProps } from "@mui/material";

export const wrapperFooter: SxProps = {
  position: "absolute",
  bottom: "0",
  width: "100%",
  "& hr": {
    border: "1px solid #E4E4E726",
  },
  "@media (max-width: 1006px)": {
    display: "none",
  },
};
